export const margin = {
  m10: 10,
  m20: 20,
  m35: 35,
  m50: 50,
  m60: 60
};
